var _a;
import { __decorate, __extends } from "tslib";
var mediaQueries = require('../../media-queries.json');
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
var GalleryOffer = /** @class */ (function (_super) {
    __extends(GalleryOffer, _super);
    function GalleryOffer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.glideOptions = {
            type: 'carousel',
            perView: 1,
            gap: 0,
            direction: 'ltr'
        };
        _this.mqData = mediaQueries;
        _this.currentSlideIndex = 0;
        _this.lastSlideIndex = null;
        _this.slideCount = null;
        return _this;
    }
    GalleryOffer.prototype.created = function () {
        var _this = this;
        var slot = this.$slots.default;
        if (slot) {
            slot.map(function (x, i) {
                _this.$slots.default[i] = _this.$createElement('vue-glide-slide', [_this.$slots.default[i]]);
            });
            this.slideCount = this.$slots.default.length;
            this.lastSlideIndex = this.slideCount - 1;
        }
    };
    GalleryOffer.prototype.handleBeforeChange = function (data) {
        if (data.direction === '<') {
            this.currentSlideIndex--;
            if (this.currentSlideIndex < 0) {
                this.currentSlideIndex = this.lastSlideIndex;
            }
        }
        else {
            this.currentSlideIndex++;
            if (this.currentSlideIndex > this.lastSlideIndex) {
                this.currentSlideIndex = 0;
            }
        }
    };
    GalleryOffer.prototype.prev = function (e) {
        e.preventDefault();
        e.stopPropagation();
        //@ts-ignore
        var slider = this.$refs.glide;
        //@ts-ignore
        slider.go('<');
    };
    GalleryOffer.prototype.next = function (e) {
        e.preventDefault();
        e.stopPropagation();
        //@ts-ignore
        var slider = this.$refs.glide;
        //@ts-ignore
        slider.go('>');
    };
    __decorate([
        Prop()
    ], GalleryOffer.prototype, "countdown", void 0);
    GalleryOffer = __decorate([
        Component({
            components: (_a = {},
                _a[Glide.name] = Glide,
                _a[GlideSlide.name] = GlideSlide,
                _a)
        })
    ], GalleryOffer);
    return GalleryOffer;
}(Vue));
export default GalleryOffer;
